import { Link, LinkProps } from '@chakra-ui/react';

interface ExternalLinkProps extends LinkProps {
  underline?: boolean;
}

export function ExternalLink({
  underline = true,
  children,
  ...props
}: ExternalLinkProps) {
  return (
    <Link
      isExternal
      color="text.primary"
      borderBottom={underline ? '1px solid' : 'none'}
      borderColor="line.subtle"
      pb={underline ? '1px' : '0'}
      transition="color 0.2s ease, border-color 0.2s ease"
      _hover={{
        color: 'accent.500',
        borderColor: 'accent.500',
        textDecoration: 'none',
      }}
      {...props}
    >
      {children}
    </Link>
  );
}
